import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

import appReducers from "./appSlices"; // Import combined reducers
// import { decryptData } from "../hooks/useAuth";
import { decryptData } from "../utils/encryptionUtils";
import { extractClaim } from '../utils/commonUtils';

// Decrypt auth data to get the user ID
const authData = decryptData(localStorage.getItem("auth"));
const userID = extractClaim(authData?.accessToken, "sub");

// Persist config for `siteName`, always persisted
const siteNamePersistConfig = {
    key: "siteName",
    storage: storageSession,
};

const chatPersistConfig = userID ? { key: `ch-${userID}`, storage: storageSession } : null;
const bookmarksPersistConfig = userID ? { key: `bm-${userID}`, storage: storageSession } : null;
const notificationsPersistConfig = userID ? { key: `nt-${userID}`, storage: storageSession } : null;

const persistedSiteNameReducer = persistReducer(siteNamePersistConfig, appReducers.siteName);
const persistedAuthReducer = appReducers.auth;
const persistedChatReducer = chatPersistConfig ? persistReducer(chatPersistConfig, appReducers.chat) : appReducers.chat;
const persistedBookmarksReducer = bookmarksPersistConfig ? persistReducer(bookmarksPersistConfig, appReducers.bookmarks) : appReducers.bookmarks;
const persistedNotificationsReducer = notificationsPersistConfig ? persistReducer(notificationsPersistConfig, appReducers.notifications) : appReducers.notifications;

// Configure store with individually persisted reducers
const store = configureStore({
    reducer: {
        siteName: persistedSiteNameReducer,
        auth: persistedAuthReducer,
        chat: persistedChatReducer,
        bookmarks: persistedBookmarksReducer,
        notifications: persistedNotificationsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
});

// Create a persistor
export const persistor = persistStore(store);

export default store;
